import { gql } from '@apollo/client'
import { RockpoolItem } from '../../../../types/RockpoolTypes'

export interface HotPoolsVars {
  chainId: number
  limit?: number
  offset?: number
}

export interface HotPoolsData {
  rockpoolHotPoolItems: RockpoolItem[]
}

export const HOT_POOLS_QUERY = gql`
  query RockpoolHotPoolsItems($chainId: Int!) {
    rockpoolHotPoolItems(chainId: $chainId) {
      amount
      buyersCount
      chainId
      creator
      description
      isErc721Available
      fee
      fractions
      fractionsCount
      id
      lastBuyers {
        ownership
        id
        fractionsCount
        buyer
        amount
      }
      listed
      name
      paymentToken {
        symbol
        name
        id
        decimals
      }
      poolProgress
      priceMultiplier
      reservePrice
      seller
      sellerFeeAmount
      sellerNetAmount
      status
      symbol
      target {
        tokenURI
        tokenId
        metadata {
          animation_url
          asset_contract {
            schema_name
            name
          }
          animationType
          description
          image
        }
        id
        contract_type
        collection {
          symbol
          name
          id
        }
        chainId
        boxItemCount
      }
      targetPrice
      timestamp
    }
  }
`
